import { IBondGelemReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_YIELD_LINKED';

export type IReportYieldLinkedItem = IBondGelemReport & { __isSelected: boolean };
